import React, { MouseEventHandler } from 'react';

export const AppVisibilityEditButton: React.FC<{
  children?: React.ReactNode;
  onClick: MouseEventHandler;
  disabled: boolean;
}> = ({ onClick, disabled, children }) => (
  <button
    type="button"
    className="hover:shadow-reg-hover shadow-reg cursor-pointer border-solid border border-gray-200 bg-white text-[#3C4149] px-4 hover:shadow-md
    transition-colors duration-250 ease-in-out transition-shadow duration-250
    ease-in-out transition-border duration-250 ease-in-out rounded-4"
    onClick={onClick}
    disabled={disabled}
  >
    {children}
  </button>
);
